// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maropost-app .drawer-below-header[data-v-2955295f]:not(.legacy-app *) {
  top: 64px !important;
  height: calc(100vh - 64px) !important;
}
.maropost-app .drawer-below-header + .v-navigation-drawer__scrim[data-v-2955295f]:not(.legacy-app *) {
  top: 64px !important;
  height: calc(100vh - 64px) !important;
}`, "",{"version":3,"sources":["webpack://./src/lib/components/DrawerHost.vue"],"names":[],"mappings":"AACA;EACC,oBAAA;EACA,qCAAA;AAAD;AACC;EACC,oBAAA;EACA,qCAAA;AACF","sourcesContent":["\n.drawer-below-header {\n\ttop: 64px !important;\n\theight: calc(100vh - 64px) !important;\n\t& + .v-navigation-drawer__scrim {\n\t\ttop: 64px !important;\n\t\theight: calc(100vh - 64px) !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
